import React from 'react'
import { IDropdownSelectItem } from './DropdownSelect'
import IconLabel from './IconLabel'

class DropdownSelectButton extends React.Component<IDropdownSelectItem> {
  public content(): JSX.Element | JSX.Element[] | string {
    return (
      <React.Fragment>
        {this.props.icon && <i className={`fas fa-${this.props.icon} mr-2`} />}
        {this.props.children}
      </React.Fragment>
    )
  }

  public render(): JSX.Element {
    return (
      <button
        key={this.props.id}
        className="btn dropdown-item"
        onClick={this.props.onClick}
      >
        <IconLabel icon={this.props.icon} label={this.props.children} />
      </button>
    )
  }
}

export default DropdownSelectButton
